import { render, staticRenderFns } from "./resultadoBusca.vue?vue&type=template&id=82f7d192&scoped=true"
import script from "./resultadoBusca.vue?vue&type=script&lang=js"
export * from "./resultadoBusca.vue?vue&type=script&lang=js"
import style0 from "./resultadoBusca.vue?vue&type=style&index=0&id=82f7d192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f7d192",
  null
  
)

export default component.exports